module.exports = __webpack_public_path__ + "img/siscov_logo_nova.e778260d.png";